"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const uuid_1 = require("uuid");
const getDefaultDueDate_1 = tslib_1.__importDefault(require("./getDefaultDueDate"));
const emptySubmission = () => {
    const submission = {
        _id: uuid_1.v4(),
        rawScore: 0,
        gradedBy: null,
        progressMeasure: 0,
        response: '',
        answerEvaluation: '',
        responseType: '',
        submittedOn: getDefaultDueDate_1.default(),
        reviewsReceivedCount: 0
    };
    return submission;
};
exports.default = emptySubmission;
//# sourceMappingURL=emptySubmission.js.map